module.exports = __webpack_public_path__ + "img/banner.f3b24972.jpg";